import { makeObservable, observable } from "mobx";
import { FormChangePassword } from "./FormChangePassword";

export class StoreChangePassword {
  @observable.ref form = new FormChangePassword();

  constructor() {
    makeObservable(this);
  }

  static create() {
    return new StoreChangePassword();
  }
}
